import React, { useState } from 'react'
import { Button, Dialog } from '@cicero/ui'
import { PageDoc } from '../../models'

export const PageShareButton = ({ page }: { page: PageDoc }) => {
  const [shareOpen, setShareOpen] = useState(false)

  return <>
    <Button onClick={() => setShareOpen(true)}>Share</Button>
    <Dialog open={shareOpen} onClose={() => setShareOpen(false)}>
      Share { page.title } With Users
    </Dialog>
  </>
}
